import { pb } from './pocketbase';

const handleRequest = async (request, errorMsg) => {
  try {
    return await request();
  } catch (error) {
    console.error(errorMsg, error);
    throw error;
  }
};

export const getBanners = async ({ page = 1, perPage = 10, filter = null } = {}) => {
  const options = {
    sort: '-created',
    ...(filter && { filter }),
  };

  const result = await handleRequest(
    () => pb.collection('banners').getList(page, perPage, options),
    'Erreur lors de la récupération des bannières:'
  );
  
  return {
    items: result.items,
    totalPages: result.totalPages,
    totalItems: result.totalItems,
    page: result.page,
    perPage: result.perPage,
  };
};

export const getBannerById = async (id) => {
  return handleRequest(
    () => pb.collection('banners').getOne(id, { expand: 'user_id' }),
    'Erreur lors de la récupération de la bannière:'
  );
};

export const createBanner = async (bannerData) => {
  return handleRequest(
    () => pb.collection('banners').create(bannerData),
    'Erreur lors de la création de la bannière:'
  );
};

export const updateBanner = async (id, bannerData) => {
  return handleRequest(
    () => pb.collection('banners').update(id, bannerData),
    'Erreur lors de la mise à jour de la bannière:'
  );
};

export const deleteBanner = async (id) => {
  await handleRequest(
    () => pb.collection('banners').delete(id),
    'Erreur lors de la suppression de la bannière:'
  );
  return true;
};

export const deleteBanners = async (ids) => {
  const promises = ids.map((id) =>
    handleRequest(
      () => pb.collection('banners').delete(id),
      `Erreur lors de la suppression de la bannière avec l'ID ${id}:`
    )
  );
  await Promise.all(promises);
  return true;
};

export const getActiveBanners = async () => {
  try {
    const result = await pb.collection('banners').getList(1, 50, {
      filter: 'status = true',
      sort: '-created',
    });
    return result.items;
  } catch (error) {
    console.error('❌ ERREUR getActiveBanners:', error);
    return [];
  }
};